import Vue from 'vue';
import Router from 'vue-router';

import { configRouterPermission } from './permission';
import { constantRoutes, constantRoutesWithoutRoot } from './paths';

Vue.use(Router);

const createRouter = (withoutRoot = false) =>
  new Router({
    mode: 'history',
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    },
    base: process.env.BASE_URL,
    routes: withoutRoot ? constantRoutesWithoutRoot : constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter(withoutRoot = false) {
  const newRouter = createRouter(withoutRoot);
  (router as any).matcher = (newRouter as any).matcher; // reset router
}

// Configure router permission
configRouterPermission(router);

export default router;
